import {AxiosResponse} from "axios";
import axiosInstance from "./base";
import {THorse} from "../shared/types/horse.type";
import {UpdateHorseHeightDto} from "../dto/UpdateHorseHeightDto";
import {UpdateHorseWeightDto} from "../dto/UpdateHorseWeightDto";
import {THorseHeight} from "../shared/types/HorseHeight.type";
import {THorseWeight} from "../shared/types/HorseWeight.type";
import {isEmpty} from "lodash";
import {UpdateHorseHrDto} from "../dto/UpdateHorseHrDto";
import {UpdateHorseCommentDto} from "../dto/UpdateHorseCommentDto";

export class Horse {

    static getHorse(id?: number, horseParams?: string[]): Promise<AxiosResponse<THorse>> {
        return axiosInstance.get(`horses/${id}`
            .concat(!isEmpty(horseParams) ? `?${horseParams?.join('&')}` : '')
        )
    }

    static updateHorseHeight(data: UpdateHorseHeightDto) {
        return axiosInstance.post('horse_heights', data)
    }

    static updateHorseWeight(data: UpdateHorseWeightDto) {
        return axiosInstance.post('horse_weights', data)
    }

    static updateHorseHr(data: UpdateHorseHrDto) {
        return axiosInstance.post('horse_parameters', data)
    }

    static getHorseHeights(id?: string): Promise<AxiosResponse<THorseHeight[]>> {
        return axiosInstance.get(`horse_heights?horse=${id}`)
    }

    static getHorseWeights(id?: string): Promise<AxiosResponse<THorseWeight[]>> {
        return axiosInstance.get(`horse_weights?horse=${id}`)
    }

    static updateHorseComment(data: UpdateHorseCommentDto) {
        return axiosInstance.post('horse_comments', data)
    }

    static patchHors(id: number, data: Partial<THorse>) {
        return axiosInstance.patch(`horses/${id}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }
}